import { useState } from "react";
import { Upload } from "@phosphor-icons/react";
import { Label } from "../ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

export function UploadDialog({ open, onOpenChange, uploadType, setUploadType, onUpload, uploading }) {
  const [dragOver, setDragOver] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) onUpload(file);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) onUpload(file);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle 
            className="text-xl font-bold uppercase tracking-tight"
          >
            CSV hochladen
          </DialogTitle>
          <DialogDescription>
            Laden Sie eine Spieler- oder Schiedsrichter-Lizenzdatei hoch.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 pt-4">
          <div className="space-y-2">
            <Label className="uppercase tracking-[0.15em] text-xs font-semibold">
              Dateityp
            </Label>
            <Select value={uploadType} onValueChange={setUploadType}>
              <SelectTrigger data-testid="upload-type-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="spieler">Spieler-Lizenzen</SelectItem>
                <SelectItem value="schiedsrichter">Schiedsrichter-Lizenzen</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div
            className={`upload-zone ${dragOver ? "drag-over" : ""}`}
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={handleDrop}
          >
            <input
              type="file"
              accept=".csv,.xml,.gnumeric"
              onChange={handleFileSelect}
              className="hidden"
              id="file-upload"
              data-testid="file-upload-input"
            />
            <label htmlFor="file-upload" className="cursor-pointer">
              <Upload className="h-10 w-10 mx-auto mb-3 text-muted-foreground" />
              <p className="text-sm font-medium mb-1">
                {uploading ? "Wird hochgeladen..." : "Datei hierher ziehen"}
              </p>
              <p className="text-xs text-muted-foreground">
                oder <span className="text-primary underline">durchsuchen</span>
              </p>
            </label>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
